import { useContext, useEffect, useState } from "react";
import { GoBackButton, MagicButton, StandardButton } from "../atoms/buttons";
import { LessonStepBar } from "../components/lessonStepBar";

import { Difficulty, TitleDescription, TitleFunction } from "../components/titleDescription";

import { HorizontalLayout, VerticalLayout, VerticalPageLayout } from "../components/layout";
import { QuizStepper, QuizStepperNew } from "../components/quizStepper.js";
import { getAPI, postAPI, updateAPI,fetchAPI } from "../api/api.js";
import { PageContext, UserContext } from "../App.js";
import { SelectImageComp } from "../molecule/selectImageComp.js";
import { ImageSelectorModalCopy, EditCourseModal, ScoreOverviewModal } from "../components/customModals.js";
import { PublishNavigation } from "../molecule/publishMenuBar.js";
import { CourseSettingComp } from "../components/courseSettingsComp.js";
import { icon } from "../functions/icons.js";
import { Alert } from "../components/alert.js";
import { set } from "date-fns";
import { HeaderTitle } from "../molecule/headerTitle.js";
import { Modal, ModalBody, ModalTitle } from "../components/modal.js";
import { ToggleSwitch } from "../molecule/ToggleSwitch.js";
import { TitleAtom } from "../atoms/titleAtom.js";
import { margin } from "polished";
import { Spinner } from "../atoms/spinner.js";
import { TitleAction } from "../molecule/TitleAction.js";
import PublishCourseComp from "../components/PublishCourseComp.js";


export function PublishCourse({ publish, pageSwap, course, start }) {
  const [courseData, setCourseData] = useState([])
  const [activeModal, setActiveModal] = useState(false)
  const [description, setDescription] = useState(null);
  const navigationContext = useContext(PageContext)
  const [userAvatar, setUserAvatar] = useState(null);
  // const [creditValue, setCreditValue] = useState(0)
  const [deactivateVisible, setDeactivateVisible] = useState(false);
  const courseId = navigationContext.sidebar.courseID;
  useEffect(() => {
    console.log(navigationContext.sidebar.userId)
    loadCurrentCourse()
  }, [])
  
  useEffect(() => {
    if (navigationContext.sidebar.userId !== 0 && navigationContext.sidebar.userId !== "@me") {
      fetchUserData();
    }
  }, [navigationContext.sidebar.userId]);

 
  const loadCurrentCourse = async () => {
    const query = `api/courses/${courseId}`
    const load = await getAPI(query)
    if (load.status === "ok") {
      setCourseData(load.data[0])
      return
    }
    setCourseData([])
  }
  const openSelector = () => {
    setActiveModal(!activeModal)
  }

  const selectImage = (value) => {
    const copyCourse = { ...courseData }
    copyCourse.image_url = value.image.url
    
    setCourseData(copyCourse)
    openSelector()


  }
  const handleGoBack = () => {
    const { courseID } = navigationContext.sidebar;
    const isPublished = courseData?.published;
    if (isPublished) {
      const targetNavigation =  navigationContext.sidebar?.back_page || 2;
      navigationContext.handleNavigation({ courseID: 0, navigation: targetNavigation, enrollment: 0, back_page: null, userId:0 });
    } else {
      const targetNavigation = courseID && courseID !== 0 ? 5 : 2;
      navigationContext.handleNavigation({ courseID, navigation: targetNavigation, enrollment: 0, back_page: null, userId:0 });
    }
  };
  const renderUserProgress = () => {
    const userId = navigationContext.sidebar.userId;
    console.log("show:", userId);
    if (userId === 0 || userId === "@me") {
      return
    } else {
      return userAvatar;  
    }
  };
const fetchUserData = async () => {
  const user_information = await fetchAPI(`api/users/${navigationContext.sidebar.userId}`);
  if (user_information.details) {
    const userName = user_information.details.full_name;
    console.log(userName);
    setUserAvatar(
      <img
        className="rounded-img"
        style={{ height: "4rem", width: "4rem", margin: "0px 0px 0.5rem 0px" }}
        src={`https://ui-avatars.com/api/?name=${userName}&background=random&color=fff&format=svg`}
        alt={`${userName} Avatar`}
      />
    );
  }
};
const [pendingToggleState, setPendingToggleState] = useState(null);
const isPublished = courseData?.published === 1;
const isDeactivated = courseData?.published === 2;
console.log(courseData)
const reactivateCourse = async () => {
  const query = 'api/courses/activate'; 
  const body = { id_course: courseId };
  const res = await updateAPI(query, body);
  if (res.status === 'ok') {
    await loadCurrentCourse();
    setDeactivateVisible(false);
  }
};
const deactivateCourse = async () =>{
  const query = 'api/courses/deactivate';
  const body = {id_course : courseId};
  const res = await updateAPI(query, body)
  if (res.status === 'ok'){
    await loadCurrentCourse();
    setDeactivateVisible(false);
  }
}
const deleteCourse = async () =>{
  const query = 'api/courses/delete';
  const body = {id_course : courseId};
  const res = await updateAPI(query, body)
  if (res.status === 'ok'){
    navigationContext.handleNavigation({ courseID: 0, navigation: 2, enrollment: 0 });
  }
}
const handleTogglePublish = (newState) => {
  setPendingToggleState(newState);
  setDeactivateVisible(true);
};
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const isMobile = windowWidth < 768;
    useEffect(() => {
      const onResize = () => setWindowWidth(window.innerWidth);
      window.addEventListener("resize", onResize);
      return () => window.removeEventListener("resize", onResize);
    }, []);

  return (
    <VerticalPageLayout className={`page-in-animation ${pageSwap && "page-out-animation"}`}>
      <VerticalLayout className="standard-padding publish-container" style={{ width: "unset" }}>
        <HorizontalLayout className="space-between" style={{ flexDirection: isMobile ? "column" : "row" }}>
          {isMobile && <TitleAtom title={courseData?.title} />}
          <HorizontalLayout className="phone-cursus-header">
            <GoBackButton
              title={""}
              left={true}
              color={"black-color semi-bold"}
              className={'goback-button go-back-btn'}
              goBack={handleGoBack}
            />
           {!isMobile && <TitleAtom title={courseData?.title} />}
            <div className="user-info"> {renderUserProgress()} </div> 
            {(isPublished || isDeactivated) && ( <ToggleSwitch className={"standard-margin"} checked={courseData?.published === 1} onChange={handleTogglePublish} />)}
          </HorizontalLayout>
       
        </HorizontalLayout>
        <PublishCourseComp 
          loadCourse={loadCurrentCourse}
          description={description}
          courseData={courseData}
          activeModal={activeModal}
          selectImage={selectImage}
          openSelector={openSelector}
        />
        <MenuOverviewQuiz courseData={courseData} />
      </VerticalLayout>
    
      {deactivateVisible && (<DeactivateCourseModal pendingToggleState={pendingToggleState} courseData={courseData} isPublished={isPublished} deactivateVisible={deactivateVisible} deleteCourse={deleteCourse} isDeactivated={isDeactivated} deactivateCourse={deactivateCourse} reactivateCourse={reactivateCourse} setDeactivateVisible={(value) => setDeactivateVisible(value)} courseTitle={courseData?.title}/>)}
    </VerticalPageLayout>
  

  )
}

const MenuOverviewQuiz = ({ courseData}) => {
  const [loading, setLoading] = useState(false);
  const [quizStructure, setCourseStructure] = useState([])
  const navigationContext = useContext(PageContext)
  const courseId = navigationContext.sidebar.courseID;
  const handleCollapse = (index) => {
    const copyStructure = [...quizStructure]
    copyStructure[index].collapsed = !copyStructure[index].collapsed
    setCourseStructure(copyStructure)

  }
   const loadCurrentCourseStucture = async () => {
    setLoading(true);
    const userId = navigationContext.sidebar.userId === 0 ? "@me" : navigationContext.sidebar.userId;
    const query = `api/courses/lessons/${courseId}/structure?user=${userId}`;
  
    const load = await getAPI(query);
    console.log("loaddata",load)
   if (load?.data && load.data.length > 0 && load.status === "ok") {
      const updatedStructure = load.data.map((row) => ({
        ...row,
        collapsed: false,
      }));
      setCourseStructure(updatedStructure);
      setLoading(false);
      return;
    }
    setCourseStructure([]);
    setLoading(false);
  };
  
  useEffect(() => {
    loadCurrentCourseStucture()
  }, [])
  
  if (loading) {
    console.log("loading", loading, courseData)
    return <VerticalPageLayout style={{ justifyContent: "center", }}><Spinner size="5rem" thickness="2px" color="primary-600" /></VerticalPageLayout>;
  }
  return (
    <VerticalLayout className={`standard-margin-top publish-stepper ${courseData?.published === 2 ? "inactive" : ""}`} style={{ width: "auto", gap: ".7rem",}}>
        <TitleAtom className={"standard-margin-top screen-title"} title={"Cursusoverzicht"} />
        <QuizStepper style={{ "margin": "0.5rem 0px" }}
          type="publish"
          activeSection={-1}
          goToSection={(index) => console.log(index)}
          quizStructure={quizStructure}
          toggleCollapse={handleCollapse}  />
    </VerticalLayout>

  )
}

const DeactivateCourseModal = ({deactivateVisible, setDeactivateVisible, deactivateCourse, courseTitle, reactivateCourse, courseData, deleteCourse, pendingToggleState}) => {

  const isDeleteMode = courseData.published === 0;
  const willActivate = pendingToggleState === true && courseData?.published === 2;
  const willDeactivate = pendingToggleState === false && courseData?.published === 1;
  return(
    <Modal
  dismissable={() => setDeactivateVisible(false)}
  visible={deactivateVisible}
  size="small"
  content={
    <>
      <ModalTitle
        dismissable={() => setDeactivateVisible(false)}
        hasXmark={true}
        title={isDeleteMode ? "Cursus verwijderen" : willActivate ? "Activeer cursus" : willDeactivate ? "Cursus deactiveren": ""} />
      <ModalBody
        style={{ maxWidth: "400px" }}
        content={
          <>
            <p className="standard-margin-bottom">
               {isDeleteMode ? (  <>Weet u zeker dat u de cursus <b>{courseTitle}</b> wilt <b>verwijderen</b>? Deze actie kan niet ongedaan gemaakt worden.</>
                  ) : willActivate ? ( <>Weet u zeker dat u de cursus <b>{courseTitle}</b> wilt <b>activeren</b>? De cursus wordt opnieuw zichtbaar voor gebruikers.</>
                  ) : ( <>Weet u zeker dat u de cursus <b>{courseTitle}</b> wilt <b>deactiveren</b>? De cursus zal niet langer zichtbaar zijn voor gebruikers.</> )}
            </p>
            <HorizontalLayout style={{ justifyContent: "space-between", gap: "1rem" }}>
              <StandardButton
                className="secondary-button"
                title="Nee, annuleer"
                onClick={() => setDeactivateVisible(false)}
              />
               {isDeleteMode ? (
                    <StandardButton
                      backgroundColor="error-600"
                      title="Ja, verwijder"
                      onClick={() => {
                        deleteCourse();
                        setDeactivateVisible(false);
                      }}
                    />
                  ) : willActivate ? (
                    <StandardButton
                      backgroundColor="success-600"
                      title="Activeer cursus"
                      onClick={() => {
                        reactivateCourse();
                        setDeactivateVisible(false);
                      }}
                    />
                  ) : (
                    <StandardButton
                      backgroundColor="error-600"
                      title="Ja, deactiveer"
                      onClick={() => {
                        deactivateCourse();
                        setDeactivateVisible(false);
                      }}
                    />
                  )}
            </HorizontalLayout>
          </>
        }
      />
    </>
  }
/>

  )
}